var _style, _path, _g, _path2, _path3, _g2, _g3, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _path4, _path5, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 375 270",
    style: {
      enableBackground: "new 0 0 375 270"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#AF8660;}\n\t.st1{fill:#896340;}\n\t.st2{fill:#FFEECA;}\n\t.st3{fill:#BCA77E;}\n\t.st4{fill:#63522D;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M167.1,91h-132c-13.2,0-26,10.8-26,24v104c0,13.2,12.8,24,26,24h14v20l20-20h98c13.2,0,22-10.8,22-24V115 C189.1,101.8,180.3,91,167.1,91z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M167.1,91h-16c13.2,0,22,10.8,22,24v104c0,13.2-8.8,24-22,24h16c13.2,0,22-10.8,22-24V115 C189.1,101.8,180.3,91,167.1,91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M167.1,91h-22v76.4c0,23,20.5,43.1,44,43.5v-96C189.1,101.8,180.3,91,167.1,91z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M174.7,11h154.1c15.4,0,26.4,13.7,26.4,30.9v135.7c0,17.2-11,32.1-26.4,32.1H310V235l-22.6-25.3H174.7 c-15.4,0-29.6-14.9-29.6-32.1V41.9C145.1,24.7,159.3,11,174.7,11z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M334.4,11h-15c17.8,0,30.5,13.7,30.5,30.9v135.7c0,17.2-12.7,32.1-30.5,32.1h15c17.8,0,30.5-14.9,30.5-32.1 V41.9C364.9,24.7,352.2,11,334.4,11z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M218.8,78.5h53c5.3,0,9.6,4.3,9.6,9.6v38.6c0,5.3-4.3,9.6-9.6,9.6h-53c-5.3,0-9.6-4.3-9.6-9.6V88.1 C209.2,82.8,213.5,78.5,218.8,78.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M300.1,130.6l-18.6-11.2V95.3l18.6-11.2c2.4-1.5,5.5,0.3,5.5,3.1v40.2C305.6,130.3,302.6,132.1,300.1,130.6z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M215.7,76.2h53c5.3,0,9.6,4.3,9.6,9.6v38.6c0,5.3-4.3,9.6-9.6,9.6h-53c-5.3,0-9.6-4.3-9.6-9.6V85.8 C206,80.6,210.4,76.2,215.7,76.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M297,128.4l-18.6-11.2V93.1L297,81.9c2.4-1.5,5.5,0.3,5.5,3.1v40.2C302.5,128.1,299.4,129.8,297,128.4z"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 195.7,
    cy: 163.3,
    rx: 11.2,
    ry: 10.8
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 307.1,
    cy: 163.3,
    rx: 11.2,
    ry: 10.8
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 194.3,
    cy: 161.8,
    rx: 11.2,
    ry: 10.8
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 305.6,
    cy: 161.8,
    rx: 11.2,
    ry: 10.8
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 270.1,
    cy: 163.3,
    rx: 11.2,
    ry: 10.8
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 268.6,
    cy: 161.8,
    rx: 11.2,
    ry: 10.8
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 232.7,
    cy: 163.3,
    rx: 11.2,
    ry: 10.8
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 231.2,
    cy: 161.8,
    rx: 11.2,
    ry: 10.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.2,142.9l-6.3-6.2c-1.7-1.7-2.3-4.3-1.4-6.5l3-7.6c0.9-2.3,3.1-3.8,5.6-3.8l14-0.1c3.3,0,6.1,2.7,6.1,6.1 c0,0.1,0,0.2,0,0.3c-3,53.5-48.2,64.6-65.5,66.7c-3.3,0.4-6.3-2-6.7-5.3c0-0.2,0-0.5,0-0.7l-0.1-13.5c0-2.5,1.5-4.7,3.8-5.6l7.6-3.1 c2.2-0.9,4.8-0.4,6.5,1.3l6.3,6.2C69,170.9,93.3,167.1,96.2,142.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M93.8,140.3l-6.3-6.2c-1.7-1.7-2.3-4.3-1.4-6.5l3-7.6c0.9-2.3,3.1-3.8,5.6-3.8l14-0.1c3.3,0,6.1,2.7,6.1,6.1 c0,0.1,0,0.2,0,0.3c-3,53.5-48.2,64.6-65.5,66.7c-3.3,0.4-6.3-2-6.7-5.3c0-0.2,0-0.5,0-0.7l-0.1-13.5c0-2.5,1.5-4.7,3.8-5.6l7.6-3.1 c2.2-0.9,4.8-0.4,6.5,1.3l6.3,6.2C66.6,168.3,91,164.5,93.8,140.3z"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 78.6,
    cy: 210.2,
    rx: 7.5,
    ry: 7.2
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 108.5,
    cy: 210.2,
    rx: 7.5,
    ry: 7.2
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 77.4,
    cy: 209.3,
    rx: 7.5,
    ry: 7.2
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 107.3,
    cy: 209.3,
    rx: 7.5,
    ry: 7.2
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 48.6,
    cy: 210.2,
    rx: 7.5,
    ry: 7.2
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 47.5,
    cy: 209.3,
    rx: 7.5,
    ry: 7.2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIcon);
export default __webpack_public_path__ + "static/media/app-icon.954ff5b719bdd7d6ebd3da71674d0e72.svg";
export { ForwardRef as ReactComponent };